import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/lib/api";
import { advisorApi } from "@/lib/advisorApi";
import { AdvisorAuthShell, AuthFooterLink } from "@/components/asesor/AdvisorAuthShell";

export default function AdvisorForgot() {
  const [correo, setCorreo] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setSending(true);
    setError("");
    try {
      await advisorApi.post("/asesor/auth/forgot-password", { correo: correo.trim().toLowerCase() });
      setSent(true);
    } catch (err) { setError(formatApiError(err)); }
    finally { setSending(false); }
  }

  return (
    <AdvisorAuthShell title="Olvidé mi contraseña" subtitle="Te enviaremos un enlace de un solo uso para crear una nueva." testId="page-asesor-forgot">
      {sent ? (
        <p className="rounded-sm border-l-4 border-[#C4674F] bg-[#F1F3F3] p-4 text-sm" data-testid="asesor-forgot-sent">
          Si el correo corresponde a un asesor activo, recibirás un enlace en unos minutos. Vence en 1 hora.
        </p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="asesor-forgot-form">
          <div><Label className="field-label">Correo</Label><Input type="email" required value={correo} onChange={(e) => setCorreo(e.target.value)} data-testid="asesor-forgot-email" /></div>
          {error && <p className="rounded-sm bg-red-50 p-3 text-xs text-red-700">{error}</p>}
          <button type="submit" disabled={sending} className="btn-primary w-full disabled:opacity-60" data-testid="asesor-forgot-submit">
            {sending ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>
      )}
      <AuthFooterLink to="/asesor/login" testId="asesor-forgot-back">Volver a iniciar sesión</AuthFooterLink>
    </AdvisorAuthShell>
  );
}
